import React from "react"

import { CategoriesContainer, CategoriesLink } from "./style"

const Categories = ({ categories }) => {
  console.log(!categories)
  return (
    <CategoriesContainer categoreis={categories}>
      {categories?.nodes?.map((category, index) => {
        const categoryName = category.name
        return (
          <CategoriesLink
            key={index}
            to={`/?f=${category.slug}`}
            dangerouslySetInnerHTML={{ __html: category.name }}
          />
        )
      })}
    </CategoriesContainer>
  )
}

export default Categories
